(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["flx-language-filter"] && !Shopify.designMode) return;
  try {
    class FlxLanguageFilter extends HTMLElement {
    connectedCallback() {
      this.buttons = Array.from(this.querySelectorAll(".flx-lang-btn"));
      this.emptyMsg = this.querySelector(".flx-lang-empty");

      const mapScript = this.querySelector("[data-flx-lang-map]");
      try {
        this.map = mapScript ? JSON.parse(mapScript.textContent) : {};
      } catch (e) {
        this.map = {};
      }

      this.buttons.forEach((btn) => {
        btn.addEventListener("click", () => {
          if (btn.classList.contains("is-active")) return;
          this.buttons.forEach((b) => {
            b.classList.remove("is-active");
            b.setAttribute("aria-pressed", "false");
          });
          btn.classList.add("is-active");
          btn.setAttribute("aria-pressed", "true");
          this.applyFilter(btn.dataset.lang);
        });
      });

      // Neu nachgeladene Karten (Infinite Scroll auf Collection-Seiten)
      // bekommen den aktuell aktiven Filter automatisch mit.
      this.observer = new MutationObserver(() => {
        const active = this.buttons.find((b) => b.classList.contains("is-active"));
        if (active) this.applyFilter(active.dataset.lang, true);
      });
      this.observer.observe(document.body, { childList: true, subtree: true });
    }

    applyFilter(lang, silent) {
      const targetTag = lang === "all" ? null : lang;
      const cards = document.querySelectorAll("[data-product-id]");
      let visible = 0;
      let total = 0;

      cards.forEach((card) => {
        const id = card.getAttribute("data-product-id");
        const tags = this.map[id] || [];
        const show = !targetTag || tags.indexOf(targetTag) !== -1;
        card.classList.toggle("flx-lang-hidden", !show);
        total++;
        if (show) visible++;
      });

      if (this.emptyMsg) {
        this.emptyMsg.hidden = !(targetTag && total > 0 && visible === 0);
      }
    }
  }

  if (!customElements.get("flx-language-filter")) {
    customElements.define("flx-language-filter", FlxLanguageFilter);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["flx-pill-tabs"] && !Shopify.designMode) return;
  try {
    class FlxPillTabs extends HTMLElement {
    connectedCallback() {
      this.lamp = this.querySelector('.flx-pill-lamp');
      this.tabs = Array.from(this.querySelectorAll('.flx-pill-tab'));
      if (!this.lamp || !this.tabs.length) return;

      this.tabs.forEach((tab) => {
        tab.addEventListener('mouseenter', () => this.moveLamp(tab));
        tab.addEventListener('focus', () => this.moveLamp(tab));
      });
      this.addEventListener('mouseleave', () => this.resetLamp());

      const active = this.tabs.find((t) => t.classList.contains('is-active')) || this.tabs[0];
      requestAnimationFrame(() => {
        this.moveLamp(active);
        this.classList.add('is-ready');
      });
      window.addEventListener('resize', () => this.resetLamp());
    }

    moveLamp(tab) {
      this.lamp.style.width = tab.offsetWidth + 'px';
      this.lamp.style.transform = 'translateX(' + tab.offsetLeft + 'px)';
    }

    resetLamp() {
      const active = this.tabs.find((t) => t.classList.contains('is-active')) || this.tabs[0];
      this.moveLamp(active);
    }
  }

  if (!customElements.get('flx-pill-tabs')) {
    customElements.define('flx-pill-tabs', FlxPillTabs);
  }
  } catch(e) { console.error(e); }
})();

})();
